import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RSVPSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to home after 5 seconds
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="login-container">
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '4rem', marginBottom: '20px' }}>✅</div>
        <h2 className="login-title">Payment Successful!</h2>
        <p style={{ marginBottom: '20px', fontSize: '1.1rem' }}>
          Your RSVP has been confirmed. You will receive a confirmation email shortly.
        </p>
        <div className="alert alert-success">
          <strong>Thank you for your registration!</strong>
          <br />
          We look forward to seeing you at the tournament.
        </div>
        <button
          className="submit-button"
          onClick={() => navigate('/')}
          style={{ marginTop: '20px' }}
        >
          Return to Events
        </button>
      </div>
    </div>
  );
};

export default RSVPSuccess;
